import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { INotificationMessage } from '../../tp-integrations.interface';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';

@Component({
    selector: 'se-notification-call',
    template: '',
    standalone: true,
})
export class NotificationCallComponent extends AbstractCallComponent implements OnInit {
    @Output() callNotify: EventEmitter<INotificationMessage> = new EventEmitter();

    ngOnInit(): void {
        super.ngOnInit();
        this.callInit();
    }

    protected async run(): Promise<any> {
        const message = this.parseNotifiMessageWithData();
        this.callNotify.emit(message);
    }

    parseNotifiMessageWithData = (): INotificationMessage => {
        const name = this.call.notificationMessage ?? '';
        let data: any;
        if (this.dataStore) {
            const parsedStrings = this.parseAllSourceWithDataStore(this.call);
            data = parsedStrings.notificationData ?? null;
        } else {
            const notificationData = this.call.notificationData;
            data =
                notificationData && typeof notificationData === 'string'
                    ? JSON.parse(notificationData)
                    : notificationData;
        }
        return {
            name,
            data,
        };
    };
}
